import React, {
  ComponentPropsWithoutRef,
  ElementType,
  useCallback,
} from 'react';
import classnames from 'classnames';

import Days, { DayValues } from './days/Days';
import Hours, { HoursValue } from './hours/Hours';

import './BusinessHours.scss';

export interface BusinessHoursValue {
  days: DayValues[];
  hours: HoursValue;
}

export interface BusinessHoursProps
  extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
  value?;
  onChange: (value: BusinessHoursValue) => void;
}

const BusinessHours = ({
  className,
  value: { days, hours } = {},
  onChange,
}: BusinessHoursProps) => {
  const handleChangeDays = useCallback(
    (days) => {
      if (onChange) {
        onChange({ days, hours });
      }
    },
    [onChange, hours],
  );

  const handleChangeHours = useCallback(
    (hours) => {
      if (onChange) {
        onChange({ days, hours });
      }
    },
    [onChange, days],
  );

  return (
    <div className={classnames('business-hours', className)}>
      <Days
        className="business-hours__days"
        value={days}
        onChange={handleChangeDays}
      />
      <Hours
        className="business-hours__hours"
        value={hours}
        onChange={handleChangeHours}
      />
    </div>
  );
};

export default BusinessHours;
